import { Modal } from "react-bootstrap";
import styled from "styled-components";

export const CharLimitError = styled.span`
  color: var(--Earthy-Orange-700, #C06236);
  font-family: Lato;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
`;

export const WeekChipsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 16px 0 20px 0;
`;

export const WeekChip = styled.div`
  display: flex;
  height: 40px;
  width: 80px;
  padding: 8px 16px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-radius: 40px;
  border: 0.75px solid var(--Bg-Color-for-Light-theme-400, #EFEFEF);
  background: ${({ active }) => active ? "var(--Crimson-Blush-500, #DA6C74)" : "#FFFFFF"};
  color: ${({ active }) => active ? "#FFFFFF" : "#184A61"};
  font-family: Lato;
  font-size: 14px;
  font-style: normal;
  font-weight: ${({ active }) => active ? "700" : "400"};
  line-height: 20px;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.2s, color 0.2s;
  box-sizing: border-box;
`;

export const DayAccordionRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 0;
  cursor: pointer;

  .day-label {
    color: var(--Font-Color-on-Light-theme-500, #184A61);
    font-family: Lato;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
  }
`;

export const WeekLabel = styled.div`
  color: var(--Font-Color-on-Light-theme-500, #184A61);
  font-family: Lato;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  margin-bottom: 16px;
`;

export const DayGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const DayBox = styled.div`
  display: flex;
  height: 192.6px;
  padding: 12px;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  flex: 0 0 20%;
  width: 20%;
  border: 0.75px solid var(--Bg-Color-for-Light-theme-300, #DCDCDC);
  background: var(--Bg-Color-for-Light-theme-600, #FEFEFE);
  box-sizing: border-box;
`;

export const DayNumber = styled.div`
  color: var(--Font-Color-on-Light-theme-500, #184A61);
  font-family: Lato;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 30px;
`;

export const DayYesNo = styled.div`
  color: var(--Font-Color-on-Dark-theme-100, #989898);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

export const DayBoxBottom = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const DayStatusBadge = styled.div`
  display: flex;
  padding: 3px 4px;
  align-items: flex-start;
  gap: 10px;
  border-radius: 4px;
  height: 23px;
  width: ${({ mediaType }) =>
    mediaType === "mp4" ? "47px" : mediaType === "mp3" ? "auto" : "57px"};
  background: ${({ mediaType }) =>
    mediaType === "mp4"
      ? "var(--Orchid-Mist-100, #F8EBF5)"
      : mediaType === "mp3"
        ? "var(--Earthy-Orange-100, #FCF7F0)"
        : "var(--Bg-Color-for-Light-theme-500, #F8F8F8)"};

  span {
    color: ${({ mediaType }) =>
    mediaType === "mp4"
      ? "var(--Orchid-Mist-600, #C96BAE)"
      : mediaType === "mp3"
        ? "var(--Earthy-Orange-600, #CE7841)"
        : "var(--Font-Color-on-Dark-theme-100, #989898)"};
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
`;


export const SummaryCard = styled.div`
  border-bottom: 1px solid #EFEFEF;
  padding: 16px 0;
  &:last-child {
    border-bottom: none;
  }
`;

export const SummaryRow = styled.div`
  display: flex;
  gap: 0;
  padding-bottom: 16px;
  border-bottom: 1px solid #EFEFEF;
`;

export const SummaryColumn = styled.div`
  flex: 1;
  padding-right: ${({ pr }) => pr || "0"};
  padding-left: ${({ pl }) => pl || "0"};
  border-right: ${({ divider }) => divider ? "1px solid #EFEFEF" : "none"};
`;

export const SummaryHeading = styled.div`
  color: var(--Font-Color-on-Light-theme-500, #184A61);
  font-family: Lato;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
`;

export const SummaryValue = styled.div`
  color: var(--Font-Color-on-Light-theme-500, #184A61);
  font-family: Lato;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  margin-top: 4px;
`;

export const SummaryBulletList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  gap: 8px 60px;
  margin: 8px 0 0 0;
  padding: 0;
  list-style: none;
`;

export const SummaryBulletItem = styled.li`
  color: var(--Font-Color-on-Light-theme-500, #184A61);
  font-family: Lato;
  width:200px;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  display: flex;
  align-items: center;
  gap: 6px;

  &::before {
    content: "•";
    font-size: 18px;
    line-height: 1;
  }
`;

export const StyledModalWorkout = styled(Modal)`
	.modal-dialog{
	display: flex;
    justify-content: center;
    transform: ${({ transform }) => transform && 'translate(0, 80px) translate(0, -90%) !important'};
	
    	.modal-content{
        max-height: ${({ maxHeight }) => maxHeight ? maxHeight : ''};
        width: ${({ newWidth }) => newWidth ? newWidth : '600px'};
    	  height: ${({ newHeight }) => newHeight ? newHeight : 'auto'};
    	  box-shadow: none;
    	  position: absolute;
    	  border-radius: 12px;
        overflow-y: ${({ isOverFlow }) => isOverFlow ? isOverFlow : 'auto'};
        overflow-x:hidden;
        ${'' /* overflow-y: auto;   */}

			.modal-header {
                ${'' /* padding:16px !important; */}
                padding: ${({ isPadding }) => isPadding ? isPadding : '16px !important;'};
                background: ${({ newBg }) => newBg ? newBg : 'white'};
                border-bottom: none !important; /* ✅ Removes header bottom border */
        				border-radius: 12px;
        				height: ${({ height }) => height ? height : ''};
        				>button{
        				 display: ${({ display }) => display ? display : ''};
        				}

        				.modal-container 
                        {
         					width: 100%;
         					display: block;
       				    }
                color:  #184A61;
                font-size: 18px;
                font-style: normal;
                font-weight: 700;
                line-height: 24px; 
			}
			.modal-header .close,
            .modal-header .btn-close {
     				margin-top: -2px;
     				outline: none !important;
     				display: none;
		}
	}}


   .modal-body{
    padding: 16px 24px 8px 24px !important;
   }

  .modal-footer{
      display:flex;
      flex-direction:row;
      justify-content:center;
      align-items:center;
      border:none;
      padding:0px 16px 16px 16px;


      .wrapper {
       width: 100%;
      display: flex !important;
      justify-content: flex-end !important; 
      align-items: center !important; 
      gap:16px;
}
    }
`;
